import { render, staticRenderFns } from "./MPNCheckingItem.vue?vue&type=template&id=604e677c&scoped=true"
import script from "./MPNCheckingItem.vue?vue&type=script&lang=js"
export * from "./MPNCheckingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e677c",
  null
  
)

export default component.exports